import { Styles, generateClasses } from '@lsy-netline/netline-ui';

import getAppFrameTheme from 'utils/theme';

export const preferencesMenuIconButtonClasses = generateClasses('PreferencesMenu', ['root'] as const);

export const preferencesMenuIconButtonRootClasses = generateClasses(
  preferencesMenuIconButtonClasses.root,
  ['hideIcon'] as const,
  true,
);

const styles: Styles = ({ theme }) => {
  const {
    appHeader: { iconColor, elementHoverBackgroundColor },
  } = getAppFrameTheme(theme);

  return {
    [`&.${preferencesMenuIconButtonClasses.root}`]: {
      color: iconColor,
      outlineOffset: 0,

      [`&.${preferencesMenuIconButtonRootClasses.hideIcon}`]: {
        display: 'none',
      },

      '&:hover': {
        background: elementHoverBackgroundColor,
      },
    },
  };
};

export default styles;
